import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {Module} from '../../../../data/model/module';
import {ModuleVisibility} from '../../../../data/model/moduleVisibility';
import {Organisation} from '../../../../data/model/organisation';
import {SignedRequest} from '../../../../data/model/signedRequest';
import {ModulesDataManager} from '../../../../data/modules.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component({
  selector: 'add-organisation-module-dialog',
  templateUrl: './add-organisation-module-dialog.html'
})
export class AddOrganisationModuleDialogComponent {
  module: Module;
  organisations: Organisation[];
  visibilities: ModuleVisibility[];

  nameInput = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<AddOrganisationModuleDialogComponent>,
      private uploadDataManager: UploadDataManager,
      private modulesDataManager: ModulesDataManager,
      @Inject(MAT_DIALOG_DATA) public data: any) {
    this.module = data.module;
    this.organisations = data.organisations;
    this.visibilities = this.module.visibility;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onAddClick(): void {
    this.dialogRef.close(this.visibilities);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/addOrganisation/add.organisation.module.dialog.component.ts